import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const OnlineRegistration = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Online Registration</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Online Registration
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <Form>
                                                    <p className="fw-500">Seeking Admission in Class <span style={{ color: "#E10104" }}>*</span></p>
                                                    <Form.Select aria-label="Default select example">
                                                        <option>-- Select a Class for registration --</option>
                                                        <option value="Nursery">Nursery</option>
                                                        <option value="KG">KG</option>
                                                        <option value="1">Class 1</option>
                                                        <option value="2">Class 2</option>
                                                        <option value="3">Class 3</option>
                                                    </Form.Select>

                                                    <h3 style={{}}>Student’s Information</h3>
                                                    <Row className='mt-3'>
                                                        <Col md={12} lg={6}>
                                                            <label>Student Full Name <span>*</span></label>
                                                            <input type="text" name="studentName" required />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>DOB <span>*</span></label>
                                                            <input type="date" name="dob" required />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Gender <span>*</span></label>
                                                            <div className="d-flex mt-2 ms-2 ms-sm-3">
                                                                <label>
                                                                    <input type="radio" name="gender" value="Male" style={{ width: "auto" }} /> Male
                                                                </label>
                                                                <label style={{ marginLeft: "20px" }}>
                                                                    <input type="radio" name="gender" value="Female" style={{ width: "auto" }} /> Female
                                                                </label>
                                                            </div>
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Name of Last School Attended <span>*</span></label>
                                                            <input type="text" name="lastSchool" required />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Board <span>*</span></label>
                                                            <input type="text" name="board" required />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Medium of Instruction <span>*</span></label>
                                                            <input type="text" name="medium" required />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Extra Curricular Skills <span>*</span></label>
                                                            <input type="text" name="extraSkills" required />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Academic Skills <span>*</span></label>
                                                            <input type="text" name="academicSkills" required />
                                                        </Col>

                                                    </Row>

                                                    <h3 style={{ margin: "10px 0", padding: '8px', backgroundColor: '#faf8f2', borderRadius: '14px' }}>Parent’s/Guardian’s Information</h3>

                                                    <Row className='mt-3'>
                                                        <Col md={12} lg={4}>
                                                            <label>Father’s Name <span>*</span></label>
                                                            <input type="text" name="fatherName" required />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Occupation <span>*</span></label>
                                                            <input type="text" name="fatherOccupation" required />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Qualification <span>*</span></label>
                                                            <input type="text" name="fatherQualification" required />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Mother’s Name <span>*</span></label>
                                                            <input type="text" name="motherName" required />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Occupation <span>*</span></label>
                                                            <input type="text" name="motherOccupation" required />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Qualification <span>*</span></label>
                                                            <input type="text" name="motherQualification" required />
                                                        </Col>
                                                        <Col md={12}>
                                                            <label>Family Annual Income <span>*</span></label>
                                                            <select name="annualIncome" required>
                                                                <option value="">--Select--</option>
                                                                <option value="Below 2 Lakh">Below 2 Lakh</option>
                                                                <option value="2-5 Lakh">2-5 Lakh</option>
                                                                <option value="5-10 Lakh">5-10 Lakh</option>
                                                                <option value="Above 10 Lakh">Above 10 Lakh</option>
                                                            </select>
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Guardian’s Name</label>
                                                            <input type="text" name="guardianName" />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Relationship with Student</label>
                                                            <input type="text" name="guardianRelation" />
                                                        </Col>
                                                        <Col md={12}>
                                                            <label>Correspondence Address</label>
                                                            <input type="text" name="address" />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>City</label>
                                                            <input type="text" name="city" />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>Pin Code</label>
                                                            <input type="text" name="pinCode" />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>State</label>
                                                            <input type="text" name="state" />
                                                        </Col>
                                                        <Col md={12} lg={6}>
                                                            <label>District</label>
                                                            <input type="text" name="district" />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Contact No.</label>
                                                            <input type="text" name="contactNo" />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>WhatsApp No.</label>
                                                            <input type="text" name="whatsAppNo" />
                                                        </Col>
                                                        <Col md={12} lg={4}>
                                                            <label>Email</label>
                                                            <input type="email" name="Email" />
                                                        </Col>

                                                        <Col md={12} lg={4}>
                                                            <label style={{ fontWeight: '400' }}>
                                                                <input type="checkbox" name="gender" value="Male" className="me-2 w-auto" /> I agree to these
                                                            </label>
                                                        </Col>
                                                    </Row>

                                                    <div className="submit_btn">
                                                        <button type="submit">Submit Now</button>
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="online-registration" target="_self" className="submenu">
                                                        Online Registration                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="admission-procedure"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Admission Procedure
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="fees-structure" target="_self" className="submenu">
                                                        Fees Structure
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="download-brochure" className="submenu">
                                                        Download Brochure
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default OnlineRegistration;